import React, { useState, useRef, useEffect } from 'react';
import { useTranslations } from 'next-intl';
import PropTypes from 'prop-types';
import Headline from '../../atoms/headline/headline';
import StyledDateSelect from './dateSelect.style';
import { AngleDown } from '../../icons/arrow/arrow';
import CalendarFilter from '../calendar/calendarFilter';

const DateSelect = ({ label, defaultValue, onChange, activeDates = [] }) => {
  const t = useTranslations();
  const [selection, setSelection] = useState(defaultValue || new Date());

  const [lastSelection, setLastSelection] = useState(defaultValue || new Date());
  const [open, setOpen] = useState(false);
  const popupRef = useRef();

  const onFilterChange = (value, type) => {
    setSelection(value);

    if (type === 'day' || type === 'date') {
      setOpen(false);
    }
  };

  useEffect(() => {
    if (open === false && onChange && selection.valueOf() !== lastSelection.valueOf()) {
      onChange(selection);
      setLastSelection(selection);
    }
  }, [selection, lastSelection, open]);

  return (
    <StyledDateSelect>
      <div className="date-select">
        <Headline className="date-select__headline" tag="h3" main>
          {label}
        </Headline>

        <div className="date-select__inner">
          <button
            className="date-select__button"
            type="button"
            onClick={() => setOpen(prev => !prev)}
          >
            {selection.toLocaleString('de', { day: '2-digit', month: '2-digit', year: 'numeric' })}
            <AngleDown />
          </button>
        </div>

        <div
          ref={popupRef}
          className={`date-select__popup ${open ? 'date-select__popup--open' : ''}`}
        >
          <CalendarFilter
            initialDate={selection}
            filterChange={onFilterChange}
            activeDates={activeDates}
          />
        </div>
      </div>
      {open && (
        <button
          type="button"
          onClick={() => setOpen(false)}
          className="date-select-close-background"
          aria-label={t('close')}
        />
      )}
    </StyledDateSelect>
  );
};

DateSelect.propTypes = {
  label: PropTypes.string,
  defaultValue: PropTypes.shape(),
  onChange: PropTypes.func,
  activeDates: PropTypes.arrayOf(PropTypes.shape)
};

export default DateSelect;
